import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button, FormInput, FormTextArea, MasterDetailForm, notification, Row, Widget } from '@digital/ui';

import StepPanel, { StepsInterface, StepInterface } from '@app/components/Steps/StepPanel';
import { PerguntaRespostaComponent } from '@app/components/PerguntaRespostaComponent';
import {
  getAllPerguntaQuestionarioMinuta,
  IPerguntaRespostaSelecionadas,
  PerguntaQuestionarioMinuta,
  postQuestionarioMinuta,
} from '@app/api/minuta/QuestionarioMinuta';
import QuestionarioContextProvider from '@app/hooks/useQuestionario';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';

import { Modal } from 'antd';
import { Demanda } from '@app/api/demanda';
import { hasPermissionPerfil } from '@app/helpers/permissions';
import { EGuidPerfilAcesso } from '@app/enums/EGuidPerfilAcesso';
import { getLoggedId } from '@app/helpers';

const { confirm } = Modal;

export const AbaQuestionarioMinuta = () => {
  const [loggedId] = useState(getLoggedId());
  const { demandaData, update, setUpdate } = useContext(QuestionarioContextProvider);

  const [activeStep, setActiveStep] = useState(1);
  const [dadosStep, setDadosSteps] = useState<StepsInterface[]>([]);
  const [totalStep, setTotalStep] = useState(0);
  const [respostasQuestionario, setRespostasQuestionario] = useState<IPerguntaRespostaSelecionadas[]>([]);

  useEffect(() => {
    if (demandaData) {
      getAllPerguntaQuestionarioMinuta(demandaData.id).then(data => {
        if (data) {
          definirDadosSteps(data);
        }
      });
    }
  }, [demandaData, update]);

  const getPerguntaAtualByStep = (): StepInterface => {
    var step: StepInterface = {} as StepInterface;
    dadosStep.forEach(dados => {
      step = dados.steps.find(step => step.step === activeStep) || ({} as StepInterface);
    });
    return step;
  };

  const definirDadosSteps = (perguntas: PerguntaQuestionarioMinuta[]) => {
    let tempSteps: StepsInterface[] = [];

    let minutaPerguntas = {
      title: 'MinutaContratual',
      steps: [] as StepInterface[],
    };

    if (perguntas.length > 0) {
      let tempTotal = 0;
      let stepIsAcordoEComentarioPreenchido = 0;

      perguntas.forEach((pergunta, index) => {
        var stepTemp = index + 1;
        minutaPerguntas.steps.push({
          id: pergunta.id,
          step: stepTemp,
          title: pergunta.tituloPerguntaQuestionario || pergunta.pergunta,
          description: '',
          content: (
            <PerguntaRespostaComponent
              dadosDaPergunta={pergunta}
              onGetRespostasQuestionario={setRespostasQuestionario}
              readonly={demandaData && demandaData.statusCodigo !== EStatusDemanda.AguardandoQuestionarioMinuta}
              footer={pergunta.necessitaConfirmacaoDemandante && pergunta.isDeAcordo && pergunta.comentario}
              footerReadonly={true}
            />
          ),
        });

        if (
          stepIsAcordoEComentarioPreenchido == 0 &&
          pergunta.necessitaConfirmacaoDemandante &&
          pergunta.isDeAcordo &&
          pergunta.comentario
        ) {
          stepIsAcordoEComentarioPreenchido = stepTemp;
        }

        tempTotal = stepTemp;
      });

      setTotalStep(tempTotal);

      if (stepIsAcordoEComentarioPreenchido != 0) {
        setActiveStep(stepIsAcordoEComentarioPreenchido);
      }

      if (demandaData && demandaData.statusCodigo !== EStatusDemanda.AguardandoQuestionarioMinuta) {
        setActiveStep(tempTotal);
      }

      tempSteps.push(minutaPerguntas);
    }

    setDadosSteps(tempSteps);
  };

  const prevStep = useCallback(() => {
    if (activeStep > 1) {
      setActiveStep(activeStep - 1);
    }
  }, [activeStep]);

  const nextStep = useCallback(() => {
    if (activeStep < totalStep && verificarRespostasFaltantes()) {
      setActiveStep(activeStep + 1);
    }
  }, [activeStep, totalStep, dadosStep, respostasQuestionario]);

  const verificarRespostasFaltantes = (): boolean => {
    let perguntaPorStep = getPerguntaAtualByStep();

    var respostas = respostasQuestionario.find(resposta => resposta.id == perguntaPorStep.id);
    if (!respostas) {
      notification.error('Por favor, responda a pergunta: ' + perguntaPorStep.title);
      // notification.error('A pergunta: ' + perguntaPorStep.title + ' deve ter pelo menos uma resposta');
      return false;
    }
    return true;
  };

  const onEnviarQuestionarioMinuta = () => {
    confirm({
      title: 'Enviar Questionário Minuta?',
      content:
        'Confirma enviar o questionário da minuta com as respostas que foram selecionadas? Uma vez confirmado não haverá como editar as seleções escolhidas.',
      okText: 'Sim',
      okType: 'primary',
      cancelText: 'Não',
      onOk() {
        if (demandaData) {
          var obj = {
            demandaId: demandaData.id,
            perguntas: respostasQuestionario,
          } as any;

          postQuestionarioMinuta(obj).then(data => {
            if (data) {
              setUpdate(!update);
            }
          });
        }
      },
      onCancel() { },
    });
  };

  const renderDemandaForm = (data: Demanda) => {
    return (
      data && (
        <>
          <Row>
            <FormInput
              label="Identificação"
              name="identificadorTexto"
              span={4}
              disabled
              value={data.identificadorTexto}
            />
            <FormInput label="Status" name="status" disabled span={4} value={data.status} />
            <FormInput label="Demandante" name="createdBy" span={4} disabled value={data.createdBy} />
          </Row>
          {data && data.justificativaDevolucao && data.statusCodigo === 1 ? (
            <Row>
              <FormTextArea
                label="Justificativa da Devolução"
                name="justificativaDevolucao"
                disabled
                rows={4}
                value={data.justificativaDevolucao}
              />
            </Row>
          ) : (
            <></>
          )}
        </>
      )
    );
  };

  return (
    <MasterDetailForm>
      <Widget
        actions={[
          activeStep > 1 && (
            <Button type="primary" onClick={prevStep}>
              voltar
            </Button>
          ),
          // (demandaData && (demandaData.demandanteId === loggedId || demandaData.requisitanteId === loggedId))
          hasPermissionPerfil([
            EGuidPerfilAcesso.PreContratacao,
          ]) && (
            <>
              {activeStep < totalStep ? (
                <Button onClick={nextStep}>Próximo</Button>
              ) : (
                demandaData &&
                demandaData.statusCodigo === EStatusDemanda.AguardandoQuestionarioMinuta && (
                  <Button onClick={onEnviarQuestionarioMinuta}>Enviar</Button>
                )
              )}
            </>
          )

        ]}>
        {dadosStep.length > 0 && (
          <StepPanel
            steps={dadosStep}
            activeStep={activeStep}
            DemandaForm={() => renderDemandaForm(demandaData || ({} as Demanda))}
            legend="Minuta Contratual"
          />
        )}
      </Widget>
    </MasterDetailForm>
  );
};
